import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { AuthService } from 'src/app/_services/auth.service';
import { StorageService } from 'src/app/_services/storage.service';
import { User } from 'src/app/user';
import { RawLoginData } from 'src/app/login-data-types';

import {
  faEnvelope,
  faLock,
  faLongArrowRight,
  faEye,
} from '@fortawesome/free-solid-svg-icons';
import { UtilityService } from 'src/app/_services/utility.service';
import { ProfileService } from 'src/app/_services/profile.service';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css', '../../../assets/vendor/util.css'],
})
export class LoginComponent implements OnInit {
  //title = "Sviluppo Personale | Login";
  inputs!: HTMLCollectionOf<HTMLInputElement>;
  remember_me: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly storageService: StorageService,
    private readonly utilityService: UtilityService,
    private readonly profileService: ProfileService,
    private readonly title: Title
  ) {}

  form!: FormGroup;
  isLoggedIn: boolean = false;
  formControlErrors: boolean = false;
  showPassword: boolean = false;
  logo: any;

  faEnvelope = faEnvelope;
  faLock = faLock;
  faLongArrowRight = faLongArrowRight;
  faEye = faEye;

  ngOnInit(): void {
  
      this.utilityService.setTitle('Login');
      this.title.setTitle('Login | Sviluppo personale');
      this.inputs = document.getElementsByClassName('input100') as HTMLCollectionOf<HTMLInputElement>;
      this.logo = environment.production
          ? 'assets/images/loghi/newLogo.svg'
          : environment.local
          ? 'assets/images/loghi/newLogoLocal.svg'
          : 'assets/images/loghi/newLogoDev.svg';
  
      // Inizializza il form
      this.form = new FormGroup({
          email: new FormControl('', [Validators.required, Validators.email]),
          password: new FormControl('', Validators.required),
          remember_me: new FormControl(false), // Assicurati che questo controllo esista
      });
  
      // Verifica se l'utente ha selezionato "remember me" in precedenza
      const rememberMe = localStorage.getItem('remember_me');
      if (rememberMe === 'true') {
          const rememberMeControl = this.form.get('remember_me');
          if (rememberMeControl) {
              rememberMeControl.setValue(true); // Imposta il valore del campo "remember_me" a true
          }

        this.authService.autoLogin().subscribe(
          (response) => {
            // conservo i cookie = csrf utili per il prossimo login
            localStorage.setItem('csrf', response.user.remember_me);
            if (response.status === 'success') {
              // Utente già autenticato
              this.isLoggedIn = true;
              this.router.navigate(['/secure']);
            }
          },
          (error) => {
            console.error('Errore durante l\'auto login:', error);
          }
        );
      }
  }

  onSubmit(): void {
      const formData: RawLoginData = this.form.getRawValue() as RawLoginData;
  
      this.validate();
      if (!this.formControlErrors) {
          this.authService.login(formData).subscribe((loginResponse) => {
              if (loginResponse === undefined) {
                  this.error = 'Email o password errata';
                  return;
              }
  
              // Salva lo stato di "remember me" nel localStorage
              if (formData.remember_me) {
                  localStorage.setItem('remember_me', 'true');
              } else {
                  localStorage.removeItem('remember_me');
              }
  
              this.isLoggedIn = true;
              this.router.navigate(['/secure']);
          });
      }
  }

  error: string;

  validate(): void {
      this.error = '';
  
      const emailControl = this.form.get('email');
      const passwordControl = this.form.get('password');
  
      if (emailControl && emailControl.errors) {
          this.error = 'Email richiesta';
          this.formControlErrors = true;
          return;
      }
  
      if (passwordControl && passwordControl.errors) {
          this.error = 'Password richiesta';
          this.formControlErrors = true;
          return;
      }
  
      if (emailControl && passwordControl && !emailControl.errors && !passwordControl.errors) {
          this.formControlErrors = false;
          return;
      }
  }

  hideValidate(input: HTMLInputElement): void {
    var thisAlert = document.getElementsByName(input.name)[0].parentElement;

    thisAlert?.classList.remove('alert-validate');
    thisAlert?.classList.remove('login-failed');
  }

  switchPassword(): void {
    this.showPassword = !this.showPassword;
    this.showPassword ? 'text' : 'password';
  }
}
